/*-------------SCROLL SPY-------------*/
export function scrollSpy() {
  const sectionsIDs = Array.from(document.querySelectorAll(".scrollspy"));

  let sectionsOffsets = [];

  sectionsIDs.forEach(e => (sectionsOffsets[e.id] = e.offsetTop));


    var scrollPosition =
      document.documentElement.scrollTop || document.body.scrollTop;

    for (const cur of sectionsIDs) {
      if (sectionsOffsets[cur.id] <= scrollPosition) {
        Array.from(document.querySelectorAll(".scroll")).forEach(e =>
          e.classList.remove("active-link")
        );
        Array.from(
          document.querySelectorAll(`a[data-link*= ${cur.id}]`)
        ).forEach(e => e.classList.add("active-link"));
      } else if (sectionsOffsets[cur.id] <= scrollPosition + 800) {
        Array.from(document.querySelectorAll(`.scrollspy#${cur.id}`)).forEach(
          e => e.classList.add("animated")
        );
      }
    }

}
/*-------------SMOOTH SCROLL-------------*/

export function scrollIt(
  destination,
  duration = 200,
  easing = "linear",
  callback
) {
  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return --t * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
  };

  const start = window.pageYOffset;
  const startTime =
    "now" in window.performance ? performance.now() : new Date().getTime();

  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  );
  const windowHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.getElementsByTagName("body")[0].clientHeight;
  const destinationOffset =
    typeof destination === "number" ? destination : destination.offsetTop - 75;
  const destinationOffsetToScroll = Math.round(
    documentHeight - destinationOffset < windowHeight
      ? documentHeight - windowHeight
      : destinationOffset
  );

  if ("requestAnimationFrame" in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  function scroll() {
    const now =
      "now" in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, (now - startTime) / duration);
    const timeFunction = easings[easing](time);
    window.scroll(
      0,
      Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start)
    );

    if (window.pageYOffset === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  }

  scroll();
}

